export default __webpack_public_path__ + "static/zwaag-7a932e1bab859f1b60f7a8de68098e51.webp";